import { render, staticRenderFns } from "./CommunityFilterPill.vue?vue&type=template&id=11315ef4&scoped=true&"
import script from "./CommunityFilterPill.vue?vue&type=script&lang=js&"
export * from "./CommunityFilterPill.vue?vue&type=script&lang=js&"
import style0 from "./CommunityFilterPill.vue?vue&type=style&index=0&id=11315ef4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11315ef4",
  null
  
)

export default component.exports